import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import { getDecryptedToken } from "../utils/crypto/cryptoUtils";
import BRANCHDENIEDROUTES from "../routes/branch/branchdenied.route";
import { showNoPermissionToast } from "../utils/toast/toast";

// Retrieve the token and accessPermission from localStorage
const token = getDecryptedToken("token");
const permissionDenied = getDecryptedToken("permissionDenied");
const martsdecrtpted = getDecryptedToken("selectedMartId");


// Parse the decrypted accessPermission into an array of numbers
let accessActions: number[] | undefined;
if (permissionDenied) {
  try {
    accessActions = permissionDenied.split(",").map(Number);
  } catch (error) {
    console.error("Error parsing accessPermission:", error);
  }
}

// Create Axios instance with base URL and headers
const baseUrl: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    Authorization: `Bearer ${token || ""}`,
    martId: martsdecrtpted || "",
    "Content-Type": "application/json; charset=utf-8",
  },
});



// Request interceptor to check access permissions
baseUrl.interceptors.request.use((config) => {
  for (const action of BRANCHDENIEDROUTES) {
    if (
      accessActions?.includes(action?.KEY) &&
      config.url?.includes(action.PATH)
    ) {
      const customError: AxiosError = new Error("Blocked") as AxiosError;
      customError.response = {
        status: 403,
        statusText: "Unauthorized",
        data: "Blocked",
        headers: {},
        config: config,
      };
      customError.config = config;
      customError.isAxiosError = true;
      customError.toJSON = () => ({
        message: "Blocked",
        name: "AxiosError",
        config: config,
        response: {
          status: 403,
          statusText: "Unauthorized",
          headers: {},
          data: "Blocked",
        },
      });

      showNoPermissionToast();

      // window.location.href = "/forbidden";

      throw customError;
    }
  }
  return config;
});

// Response interceptor to handle unauthorized responses
baseUrl.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default baseUrl;
